import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Modal } from 'antd';
import { STRIPE_KEY } from '../../../constants';
import CheckoutForm from './CheckoutForm';

export const StripePaymentModal = ({
  visible,
  handleClose,
  handleDone,
  clearSteps,
  documents,
  values,
  documentsMap,
  returnLessons,
  selectedSteps,
  templateId,
  setLoginModalVisible
}) => {
  return (
    <Modal
      centered
      visible={visible}
      onCancel={handleClose}
      className="stripePaymentModal"
      cancelButtonProps={{ style: { display: 'none' } }}
      okButtonProps={{ style: { display: 'none' } }}
      maskStyle={{ padding: 0 }}
      style={{ margin: 0 }}
      footer={null}>
      <div style={{ minHeight: '80vh' }}>
        <CheckoutForm
          templateId={templateId}
          returnLessons={returnLessons}
          documentsMap={documentsMap}
          documents={documents}
          selectedSteps={selectedSteps}
          clearSteps={clearSteps}
          onSuccess={handleDone}
          values={values}
        />
      </div>
    </Modal>
  );
};
